import CurrencyFilterModel from 'Models/CurrencyFilterModel';

// eslint-disable-next-line import/prefer-default-export
export function transformFilterEntryIntoMeilisearchParams(entry) {
  const fieldId = entry.field.fieldData.id;
  let key;
  let value;

  if (
    entry.field.fieldData.component_edit === CurrencyFilterModel.ID_BY_FIELD.MULTIPLE_GRID_SELECT
    && entry.value
  ) {
    key = 'values';
    value = entry.value.map((item) => item.value);
  } else if (
    entry.field.fieldData.has_values_counter
    && entry.range
  ) {
    key = 'range';
    value = entry.range;
  } else if (
    entry.field.fieldData.has_custom_value
    && entry.value.length
  ) {
    key = 'custom_range';

    // TODO: тут я чет проебал момент, что у нас custom_range это массив с массивами,
    // и мы можем выбрать два кастом ренжа.
    // к примеру клиент выбрал отрезки [1, 100] и [200, 300]
    // и мы должны отправить на бэк массив с двумя массивами.
    // на текущий момент бэк принимает только один массив, поэтому ищем по границам
    // нужно поставить задачу на доработку этого момента.
    const array = entry.value.sort((a, b) => a.min - b.min);

    let min;
    let max;

    // Поддерживаем оба формата входящих данных.
    // В случае если приходит массив с объектами, который приходит например от селекта
    // то берем min и max из объектов.
    // В случае если приходит массив с числами, то берем min и max из чисел.
    if (typeof array[0] === 'object') {
      min = array[0]?.min;
      max = array[array.length - 1]?.max;
    } else {
      // eslint-disable-next-line prefer-destructuring
      min = array[0];
      max = array[array.length - 1];
    }

    value = [min, max];
  } else {
    key = 'values';
    value = entry.value.map((item) => item.value);
  }

  return {
    fieldId,
    key,
    value,
  };
}
